import React from 'react'

export default function SubGradeInput({inputname, lesson, setLesson, grade, setGrade}) {
    //console.log("inputname",inputname);

    function GetGradeColor(grade) {      
      let color = "#FFFFFF"
      if (grade > 0 && grade < 65) color = '#FF0000'
      if (grade > 64 && grade < 71) color = '#FFA500'
      if (grade > 70 && grade < 81) color = '#FFFF00'
      if (grade > 80 && grade < 91) color = '#32CD32'
      if (grade > 90) color = '#1E90FF'
   
    return { backgroundColor: color }
    }

  return (
    <div className="d-flex gap-1">
      <div className='col-6'>
    <input
      type="text"
      name={inputname}
      value={lesson}      
      onChange={(e) => setLesson(e.target.value)}
      className="form-control form-control-sm m-1 border border-secondary"
     // style={{minWidth:"60px", maxWidth:"170px"}}
      placeholder="-"
      style={GetGradeColor(grade)}
    />
    </div>
    <div className='col-6'>
    <input
      type="number"
      name="note1"
      value={grade}
     onChange={(e) => setGrade(e.target.value)}
      className="form-control form-control-sm m-1 border border-secondary"
      //style={{minWidth:"20px", maxWidth:"100px"}}
      placeholder="0"
      style={GetGradeColor(grade)}
    />
     </div>
  </div>
 )
}
